import SearchField from './SearchField'
import { withSearchField } from './withSearchField'

const ConnectedSearchField = withSearchField(SearchField)

export { ConnectedSearchField as SearchField }
